import React from 'react'
import "./CommonText.css";

export default function CommonText({ paraText }) {
    return (
        <div className='common-text'>
            <h1>{paraText}</h1>

        </div>
    )
}
